var ko = require('knockout');

var APIHelper = require('_js/APIHelper');

// Default error messages for when the validation fails.
var defaultValidationMessages = {
  isNumber: 'Feltet kan kun bestå av tall!',
  isEmail: 'Feltet må være en mailadresse!',
  isLength: 'Length!',
  isNotOnlyWhitespace: 'Feltet må bestå av mer enn bare mellomrom'
};

// Validation methods used to test if a statement is true.
var validationMethods = {
  // Is optional is the "weird" test.
  // If the user has the isOptional validation method on we want to see if
  // the input field contains content, or if the validation method was just triggered
  // by the blur event. If it is empty, we want to return true because there is nothing
  // wrong (it is optional!).
  isOptional: function(newValue) {
    return ('' + newValue).length > 0 ? true : false;
  },
  isNumber: function(newValue) {
    return /^\d+$/.test(newValue);
  },
  isDecimalNumber: function(newValue) {
    return /^(\d+(?:[.,]\d{1,2})?)$/.test(newValue);
  },
  isCheckedOff: function(newValue) {
    return newValue;
  },
  // Calculator hours are only valid if they are a positive number and is whole or 0.5 hours.
  isValidCalculatorHour: function(newValue) {
    if (newValue.length === 0) {
      return true;
    } else if (validationMethods.isPositiveNumber(newValue)) {
      return parseFloat(newValue.toString().replace(',', '.'), 10) % 0.5 === 0;
    } else {
      return false;
    }
  },
  isPositiveNumber: function(newValue) {
    if (
      validationMethods.isNumber(newValue) ||
      validationMethods.isDecimalNumber(newValue)
    ) {
      return parseFloat(newValue.toString().replace(',', '.'), 10) >= 0;
    } else {
      return false;
    }
  },
  isLargerThan: function(newValue, settings) {
    if (
      validationMethods.isNumber(newValue) ||
      validationMethods.isDecimalNumber(newValue)
    ) {
      return (
        parseFloat(newValue.toString().replace(',', '.'), 10) >
        settings.threshold
      );
    } else {
      return false;
    }
  },
  isEmail: function(newValue) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(newValue);
  },
  isLength: function(newValue, settings) {
    if (settings === undefined || settings.length === undefined) {
      throw 'Error: Need to specify length for isLength validation type';
    }
    return settings.length === newValue.length;
  },
  isMinLength: function(newValue, settings) {
    if (settings === undefined || settings.length === undefined) {
      throw '';
    }
    return newValue.length >= settings.length;
  },
  isNotOnlyWhitespace: function(newValue) {
    // We're returning true for length <= 0 even
    // though it normally would return false.
    // This is because we already have a validation method
    // for checking if something is notEmpty.
    if (newValue.length <= 0) {
      return true;
    }
    return /\S/.test(newValue);
  },
  isNotEmpty: function(newValue) {
    return ('' + newValue).length > 0;
  },
  isValidPersonNumber: function(newValue, settings) {
    if (settings === undefined || settings.api === undefined) {
      throw 'Error: Need to specify api to use for validating person number';
    }

    var deferred = $.Deferred();

    APIHelper.post(
      settings.api,
      { PersonNumber: newValue },
      function(response) {
        deferred.resolve(response);
      },
      function() {
        deferred.resolve(false);
      }
    );

    return deferred.promise();
  },
  isRNPassword: function(newValue) {
    var isValid = true;
    if (newValue.match(/\d+/g) === null) {
      isValid = false;
    } else if (
      newValue.match(/[a-z]/g) === null ||
      newValue.match(/[A-Z]/g) === null
    ) {
      isValid = false;
    }

    return isValid;
  },
  isEqualTo: function(newValue, settings) {
    if (settings === undefined || settings.value === undefined) {
      throw 'Error: Need to specify value for isEqualTo validation type';
    }
    var value =
      typeof settings.value === 'function' ? settings.value() : settings.value;
    return value === newValue;
  }
};
ko.extenders.required = function(target, requiredMethods) {
  // Add some sub-observables to our observable.
  target.hasError = ko.observable();
  target.isLoading = ko.observable();
  target.isSuccessful = ko.observable(false);
  target.validationMessage = ko.observable();
  // We want all input fields to check for not only whitespaces.
  requiredMethods.push({ type: 'isNotOnlyWhitespace' });
  // If we have the message available, assign it to the observable.
  if (requiredMethods[0] && requiredMethods[0].message) {
    target.validationMessage(requiredMethods[0].message);
  }

  function validateAsync(promise, rm) {
    target.isLoading(true);
    target.isSuccessful(false);
    promise.then(function(data) {
      target.isLoading(false);
      target.hasError(!data);
      target.isSuccessful(data);
      target.validationMessage(rm.message);
    });
  }

  function validate(newValue) {
    // If no input is given we don't want to set hasError.
    if (newValue === undefined || newValue === null) {
      return;
    } else {
      var hasError = false;
      var isSuccessful;
      var message = '';

      for (var i = 0; i < requiredMethods.length; i++) {
        var rm = requiredMethods[i];

        if (rm.type === 'isValidPersonNumber') {
          validateAsync(validationMethods[rm.type](newValue, rm), rm);
        } else {
          hasError = !validationMethods[rm.type](newValue, rm);

          // If the optional tag confirms there is no input, and it is an optional tag we don't
          // want to test the rest.
          if (hasError && rm.type === 'isOptional') {
            isSuccessful = false;
            hasError = false;
            break;
          }
          // If we have an error we can just jump out of the for loop and provide that message.
          else if (hasError && rm.type !== 'isOptional') {
            message = rm.message || defaultValidationMessages[rm.type];
            isSuccessful = false;
            break;
          } else if (rm.type !== 'isOptional') {
            if (isSuccessful === undefined) {
              isSuccessful = true;
            }
          }
        }
      }

      target.isSuccessful(isSuccessful);
      target.hasError(hasError);
      target.validationMessage(message);
    }
  }

  // Initial validation.
  validate(target());

  // Validate whenever the value changes.
  target.subscribe(validate);

  // Return the original observable.
  return target;
};
